import { Box, Center, Group, Title, rem, Tabs, FileButton, Button, Text, Modal, Select, TextInput } from "@mantine/core";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddIcon from '@mui/icons-material/Add';
import Miscformstable from "../Components/Admin/Miscformstable";
import Courtcalndertable from "../Components/Admin/Courtcalndertable";
import AddLinkIcon from '@mui/icons-material/AddLink';
import { useState } from "react";
import { message } from "antd";
import { Adminauthcontexthooks } from "../Hooks/Adminauthcontexthooks";
import { useDisclosure } from '@mantine/hooks';
import Externallinkstable from "../Components/Admin/Externallinks";


const Upload = () => {
    const { user } = Adminauthcontexthooks();
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedCourtCalender, setSelectedCourtCalender] = useState(null);
    const [loading, setloading] = useState({
        miscformsloading: false,
        courtcalenderloading: false,
        extlinkloading: false
    })
    const [selectcourt, setselectcourt] = useState('')
    const [selectsubdistcourt, setselectsubdistcourt] = useState('')
    const [selecthighcourt, setselecthighcourt] = useState('')
    const [selectforms, setselectforms] = useState('')
    const [Extlinksinputs, Setextlinksinputs] = useState({
        Extlinkname: "",
        Extlink: ""
    })
    const [opened, { open, close }] = useDisclosure(false);
    const [Extopend, { open: Extmodalopen, close: Extmodalclose }] = useDisclosure(false);

    const handleFileChange = (file) => {
        if (file) {
            setSelectedFile(file);
        }
    }
    const handleCourtCalenderChange = (file) => {
        if (file) {
            setSelectedCourtCalender(file);
        }
    }

    const handleExtlinksonchange = (e) => {
        const { name, value } = e.target;
        Setextlinksinputs({ ...Extlinksinputs, [name]: value });
    }

    const GetMiscforms = async () => {
        await fetch('https://cdr-backend.onrender.com/get/miscforms', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
    }

    const GetExtlinks = async () => {
        await fetch('https://cdr-backend.onrender.com/get/external-links', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`
            }

        });
    }

    const UploadMiscForms = async () => {
        if (!selectcourt || !selectforms) {
            message.error('Please select court and form type');
            return;
        }
        if (selectcourt === 'Dist. court' && !selectsubdistcourt) {
            message.error('Please enter sub dist. court');
            return;
        }
        if (selectcourt === 'High court' && !selecthighcourt) {
            message.error('Please enter high court');
            return;
        }
        if (!selectedFile) {
            message.error('Please select a file to upload');
            return;
        }
        // 7 MB = 2 * 1024 * 1024 bytes = 2097152 bytes
        const maxSize = 7 * 1024 * 1024;

        if (selectedFile.size > maxSize) {
            message.error('File size exceeds 7 MB');
            return;
        }
        const formData = new FormData();
        formData.append('Miscforms', selectedFile);
        formData.append('court', selectcourt);
        formData.append('subdistcourt', selectsubdistcourt);
        formData.append('highcourt', selecthighcourt);
        formData.append('formtype', selectforms);

        try {
            setloading({ ...loading, miscformsloading: true });
            // Send the file to the server
            const response = await fetch('https://cdr-backend.onrender.com/api/uploadmiscforms', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${user}`
                },
                body: formData,
            });

            if (response.status === 201) {
                message.success('File uploaded successfully');
                setloading({ ...loading, miscformsloading: false });
                setSelectedFile(null);
                GetMiscforms();
                setselectcourt('');
                setselectsubdistcourt('');
                setselectforms('');
                close();
                return;
            } else {
                message.error('File upload failed');
                setloading({ ...loading, miscformsloading: false });
                return;
            }
        } catch (error) {
            message.error('Error uploading file');
            console.error('Error uploading file:', error);
        }

    }

    const UploadCourtCalender = async () => {
        if (!selectedCourtCalender) {
            message.error('Please select a file to upload');
            return;
        }
        // 5 MB = 5 * 1024 * 1024 bytes = 2097152 bytes
        const maxSize = 5 * 1024 * 1024;

        if (selectedCourtCalender.size > maxSize) {
            message.error('File size exceeds 5 MB');
            return;
        }
        const formData = new FormData();
        formData.append('Courtcalenderimg', selectedCourtCalender);
        try {
            setloading({ ...loading, courtcalenderloading: true });
            // Send the file to the server
            const response = await fetch('https://cdr-backend.onrender.com/api/uploadcourtcalenderimg', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${user}`
                },
                body: formData,
            });

            if (response.status === 201) {
                message.success('File uploaded successfully');
                setloading({ ...loading, courtcalenderloading: false });
                setSelectedCourtCalender(null);
                return;
            } else {
                message.error('File upload failed');
                setloading({ ...loading, courtcalenderloading: false });
                return;
            }
        } catch (error) {
            message.error('Error uploading file');
            console.error('Error uploading file:', error);
        }

    }

    const UploadExtLinks = async () => {
        const { Extlinkname, Extlink } = Extlinksinputs
        if (!Extlinkname || !Extlink) {
            message.error("Please fill all fields");
            return
        }

        try {
            setloading({ ...loading, extlinkloading: true });
            // Send the file to the server
            const response = await fetch('https://cdr-backend.onrender.com/add/external-link', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`
                },
                body: JSON.stringify({ Extlinkname, Extlink }),
            });
            if (response.status === 201) {
                message.success('Ext. Link uploaded successfully');
                setloading({ ...loading, extlinkloading: false });
                Setextlinksinputs({
                    Extlinkname: "",
                    Extlink: ""
                })
                Extmodalclose()
                GetExtlinks();
                return;
            } else {
                message.error('Ext. Link upload failed');
                setloading({ ...loading, extlinkloading: false });
                return;
            }
        } catch (error) {
            message.error('Error uploading Ext. Link');
            console.error('Error uploading Ext. Link:', error);
        }

    }
    return (
        <>
            <Center mt={'xs'}><Title c={'dimmed'}>Upload: Draft || Calender || Ext. Link</Title></Center>
            <Tabs color="violet" variant="pills" radius="xl" defaultValue="miscforms" mt={'lg'}>
                <Tabs.List>
                    <Tabs.Tab value="miscforms" leftSection={<InsertDriveFileIcon size={12} />}>
                        Legal Drafts
                    </Tabs.Tab>
                    <Tabs.Tab value="courtcalender" leftSection={<CalendarMonthIcon size={12} />}>
                        Court Calender
                    </Tabs.Tab>
                    <Tabs.Tab value="extlinks" leftSection={<AddLinkIcon size={12} />}>
                        Ext. Links
                    </Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="miscforms" mt={'md'}>
                    <Modal opened={opened} onClose={close} title="Upload Legal Draft's">
                        <Select label="Select Court" placeholder="Pick value" data={['Supreme court', 'High court', 'Dist. court']} mt={'xs'} name="court" value={selectcourt} onChange={(value, option) => setselectcourt(value)} withAsterisk />
                        {
                            selectcourt === 'Dist. court' && (<>
                                <TextInput label="Enter Sub Dist. Court" placeholder="Sub Dist. Court" name="subdistcourt" value={selectsubdistcourt} onChange={(e) => setselectsubdistcourt(e.target.value)} withAsterisk mt={'xs'} />
                                {/* <Select label="Select Sub Dist. Court" placeholder="Pick value" data={['Tis Hazari courts', 'Rouse Avenue courts', 'Karkardooma courts', 'Patiala House courts', 'Rohini courts', 'Dwarka courts', 'Saket courts']} mt={'xs'} name="subdistcourt" value={selectsubdistcourt} onChange={(value, option) => setselectsubdistcourt(value)} withAsterisk /> */}
                            </>
                            )
                        }
                        {
                            selectcourt === 'High court' && (<>
                                <TextInput label="Enter High. Court" placeholder="High Court" name="highcourt" value={selecthighcourt} onChange={(e) => setselecthighcourt(e.target.value)} withAsterisk mt={'xs'} />
                            </>)
                        }
                        <Select label="Select Form Type" placeholder="Pick forms" data={['Misc forms', 'Civil forms', 'Criminal forms']} mt={'xs'} name="court" value={selectforms} onChange={(value, option) => setselectforms(value)} withAsterisk />

                        <Group justify="flex-start" mt={'sm'}>
                            <FileButton onChange={handleFileChange} accept=".pdf,.docx">
                                {(props) => <Button {...props} variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} >Select File</Button>}
                            </FileButton>
                            {
                                selectedFile && (
                                    <>
                                        <Text size="xs">Selected File:- {selectedFile.name}</Text>
                                        <Button variant="light" size="sm" color="lime" onClick={UploadMiscForms} radius={'lg'} loading={loading.miscformsloading} disabled={loading.miscformsloading}>Upload Legal Draft</Button>
                                    </>)

                            }
                        </Group>
                    </Modal>
                    <Group justify="flex-end">
                        <Button variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} onClick={open}>Add Legal Draft's</Button>
                    </Group>

                    <Box mt={'md'}>
                        <Miscformstable />
                    </Box>
                </Tabs.Panel>

                <Tabs.Panel value="courtcalender" mt={'md'}>
                    <Group justify="flex-end">
                        <FileButton onChange={handleCourtCalenderChange} accept="image/jpeg, image/png">
                            {(props) => <Button {...props} variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} >Select File</Button>}
                        </FileButton>
                        {
                            selectedCourtCalender && (
                                <>
                                    <Text size="xs">Selected File:- {selectedCourtCalender.name}</Text>
                                    <Button variant="light" size="sm" color="lime" onClick={UploadCourtCalender} radius={'lg'} loading={loading.courtcalenderloading} disabled={loading.courtcalenderloading}>Upload Court Calender</Button>
                                </>)

                        }
                    </Group>
                    <Box mt={'md'}>
                        <Courtcalndertable />
                    </Box>
                </Tabs.Panel>

                <Tabs.Panel value="extlinks" mt={'md'}>
                    <Modal opened={Extopend} onClose={Extmodalclose} title="Upload External Links">
                        <TextInput label="Enter Ext. Link Name" placeholder="Link Name" name="Extlinkname" value={Extlinksinputs.Extlinkname} onChange={handleExtlinksonchange} withAsterisk />
                        <TextInput label="Enter Ext. Link" placeholder="Link" name="Extlink" value={Extlinksinputs.Extlink} onChange={handleExtlinksonchange} withAsterisk mt={'sm'} />
                        <Button mt={'md'} variant="light" size="sm" color="lime" onClick={UploadExtLinks} radius={'lg'} loading={loading.extlinkloading} disabled={loading.extlinkloading}>Upload Ext. Link</Button>
                    </Modal>
                    <Group justify="flex-end">
                        <Button variant="light" color="indigo" leftSection={<AddIcon style={{ width: rem(14), height: rem(14) }} />} onClick={Extmodalopen}>Add Ext. Links</Button>
                    </Group>
                    <Box mt={'md'}>
                        <Externallinkstable />
                    </Box>
                </Tabs.Panel>
            </Tabs>
        </>
    )
}
export default Upload;

